import React, {ChangeEvent, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

import "./AchAccountInput.scss";

interface AchAccountInputProps {
    achAccount: string;
    onSetAchAccount: (amount: string) => void;
    onSetIsAchAccountValid: (isAmountValid: boolean) => void;
}

export const AchAccountInput: React.FunctionComponent<AchAccountInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const requiredAchAccountError = 'ACH Account is a required field.';

    useEffect(() => {
        props.onSetIsAchAccountValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        let value = (event.target as HTMLInputElement).value;
        props.onSetAchAccount(value);
        validateAchAccount();
    }

    const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        validateAchAccount();
    }

    const validateAchAccount = () => {
        let errorsTemp: string[] = [];
        if (props.achAccount === '') {
            errorsTemp.push(requiredAchAccountError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    return <div className="ach-account-container">
        <Input isValid={isValid} type='text' required={true} value={props.achAccount} onChange={onChange}
               onKeyUp={onKeyUp}/>
        {errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
